// src/modules/renters/utils/paymentUtils.ts
import { PAYMENT_STATUS } from "@/types/payment.type";
import { STATUS_LABELS } from "../constants/paymentConstants";

export function getStatusLabelsPayment(status: string) {
  return STATUS_LABELS[status] || status;
}

export const withInactiveStyle = (
  content: React.ReactNode,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): React.ReactNode => {
  return data.status === PAYMENT_STATUS.Inativo
    ? <span className="text-gray">{content}</span>
    : content;
};

